<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Footnote</h5>
      <br />
    </div>
    <b-row>
      <b-col md="12">
        <b-card class="text-left">
          <b>Input Footnote</b>
          <br>
          <br>
          <b-row>
              <b-col>
                <b-form-group
                  id="fieldset-1"
                  label="Footnote (Bahasa)"
                  label-class="control-label"
                  class="required"
                  label-for="input-1"
                >
                  <summer-note v-model="items.footnote.id" name="footnote_id" placeholder="Footnote Bahasa"></summer-note>
                  <input type="hidden" v-model="items.footnote.id" v-validate="'required'" name="footnote_id" data-vv-as="Footnote Bahasa">
                  <p
                    class="text-danger"
                    style="width:100%;margin-top:.25rem;font-size: 80%;"
                  >{{ veeErrors.first('footnote_id') }}</p>
                </b-form-group>
            </b-col>
              <b-col>
                <b-form-group
                  id="fieldset-1"
                  label="Footnote (English)"
                  label-class="control-label"
                  class="required"
                  label-for="input-1"
                >
                  <summer-note v-model="items.footnote.en" name="footnote_en" placeholder="Footnote English"></summer-note>
                  <input type="hidden" v-model="items.footnote.en" v-validate="'required'" name="footnote_en" data-vv-as="Footnote English">
                  <p
                    class="text-danger"
                    style="width:100%;margin-top:.25rem;font-size: 80%;"
                  >{{ veeErrors.first('footnote_en') }}</p>
                </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col md="2" class="text-left">
              <label class="text-danger">
                *
                <b class="text-dark">Required</b>
              </label>
            </b-col>
            <b-col>
              <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">
                Save
                <b-spinner v-if="loading" small label="Loading..."></b-spinner>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const summerNote = () => import("@/components/Summernote.vue");

export default {
  components: {
    summerNote
  },
  data() {
    return {
      editorConfig: {},
      widthImage: null,
      heightImage: null,
      loading: false,
      items: [],
      urlImage: "",
      modalImage: false,
      image: ""
    };
  },
  mounted() {
    this.$store.dispatch("FootnoteModule/getFootnote").then(response => {
                  this.items = response;
                })
                .catch(error => {
                  console.log(error);
                });
  },
  created() {
    
  },
  methods: {
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Paxel.co Dashboard!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append("footnote_id", this.items.footnote.id);
              formData.append("footnote_en", this.items.footnote.en);
              this.$store
                .dispatch(
                  "FootnoteModule/postFootnote",
                  formData
                )
                .then(response => {
                  this.loading = false;
                  this.$validator.reset();
                  this.$router.push({ name: "footNote" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal("ERROR!", "Your file cant be submit.", "warning");
            }
          });
        }
      });
    },
  }
};
</script>

<style>
</style>
